import _axios from '../../apiClient'

export function getArticulo(payload) {
  return _axios.get(`/api/Articulo/GetArticuloDetalle`,
    {
      params: {
        idArticulo: payload.idArticulo,
        idInstalacion: payload.idInstalacion
      }
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      throw error
    })
}

export function getPedidoDetalle(payload) {
  return _axios.get(`/api/Pedido/GetPedidoDetalle`,
    {
      params: { id: payload }
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      throw error
    })
}

export function getArticulosRelacionados(payload) {
    return _axios.get(`/api/Articulo/GetArticulosRelacionados`,
      {
        params: {
          idArticulo: payload.idArticulo
        }
      },
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => response.data)
      .catch((error) => {
        const data = error.response.data
        throw (data)
      })
  }